import { Checklist } from './../../domain/model/checklist';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface DeleteChecklistRepository {
    (id: number): Promise<Checklist>
}

const deleteChecklistRepository = (axios: AxiosInstance): DeleteChecklistRepository => async (id: number) => {
    try {
        const response: AxiosResponse = await axios.delete(`/checklist/${id}`)

        const checklist: Checklist = response.data
        return checklist
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deleteChecklistRepository